//#region Styles
import {
    AppLogoText,
    StyledLink
} from "./styles";
//#endregion
//#region Utils
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
//#endregion

const LinkUTPHome = () => {
    return (
        <StyledLink to={ABSOLUTE_PATHS.HOME}>
            <AppLogoText>RESERVAS</AppLogoText>
        </StyledLink>
    );
}

export default LinkUTPHome;